import React, { useState } from 'react';
import { Outlet } from 'react-router-dom';
import Sidebar from '../components/common/Sidebar';
// import Header from '../components/common/Header';
// import PageTransition from '../components/common/PageTransition';

export const MainOutLet = () => {
  const [isSidebarMini, setIsSidebarMini] = useState(false);

  return (
    <div id="mytask-layout" className="theme-indigo">
      <Sidebar isSidebarMini={isSidebarMini} setIsSidebarMini={setIsSidebarMini} />
      <div className="main px-lg-4 px-md-4 py-4">
        {/* <Header setIsSidebarMini={setIsSidebarMini} isSidebarMini={isSidebarMini} /> */}
        <Outlet />
      </div>
    </div>
  );
};
